import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sortEmployees',
})
export class SortEmployeesPipe implements PipeTransform {
  transform(value: Array<{
    lastname: string,
    firstname: string
  }>): any[] {
    return value.sort((a, b) => (a.lastname + a.firstname).localeCompare((b.lastname + b.firstname)));
  }
}
